import React, { useEffect } from "react";
import "../../UpcomingHourlyComponent/UpcomingHourlyBookingTable/HourlyFloatBookingModal/HourlyFloatBookingModal.css";
import Loader from "../../../../Loader/Loader";
import BookingInfoHeader from "../../UpcomingHourlyComponent/UpcomingHourlyBookingTable/HourlyFloatBookingModal/BookingInfoHeader";
import HourlyBookingSummary from "../../UpcomingHourlyComponent/UpcomingHourlyBookingTable/HourlyFloatBookingModal/HourlyBookingSummary";
import RoleAccordion from "../../UpcomingHourlyComponent/UpcomingHourlyBookingTable/HourlyFloatBookingModal/RoleAccordion";
import {
    getFloatStaffRole,
    isHourlyStandardOrPremiumBooking,
    resolveBookingFloatBaseAmount,
    shouldShowFloatRequirement,
} from "../../UpcomingHourlyComponent/UpcomingHourlyBookingTable/HourlyFloatBookingModal/hourlyFloatHelpers";
import useCustomizeHourlyFloat from "./Hooks/useCustomizeHourlyFloat";

const CustomizeHourlyFloatModal = ({ booking, isOpen, onClose, refetchData }) => {
    const {
        services,
        loadingAddBooking,
        localBooking,
        refreshVersion,
        handleRoleSelectionChange,
        handleFooterSendRequest,
        selectedIds,
        resetAll,
        selectedPackageIndex,
        setSelectedPackageIndex,
    } = useCustomizeHourlyFloat({ booking, isOpen, onClose, refetchData });

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [isOpen]);

    if (!isOpen) return null;
    if (loadingAddBooking) return <Loader />;

    const role = getFloatStaffRole(localBooking);
    const hourlyPackages = localBooking?.hourlyPackages || [];
    const multiPlan =
        isHourlyStandardOrPremiumBooking(localBooking) &&
        hourlyPackages.length > 1;
    const baseAmount = multiPlan
        ? 0
        : resolveBookingFloatBaseAmount(localBooking);
    const bookingId =
        localBooking?.veroaBookingId || localBooking?._id || localBooking?.bookingId;
    const showRequirement = shouldShowFloatRequirement(localBooking);

    return (
        <div className="hourly-float-photographer-modal-overlay hourly-float-photographer-modal-overlay--full">
            <div className="hourly-float-photographer-modal-container hourly-float-photographer-modal-container--full">
                <BookingInfoHeader
                    booking={localBooking}
                    showRequirement={showRequirement}
                />

                <div className="hourly-modal-body hourly-modal-body--full">
                    <div className="customize-hourly-float-body-inner">
                        {multiPlan ? (
                            <>
                                <HourlyBookingSummary hourlyPackages={hourlyPackages} />
                                <label
                                    style={{
                                        fontWeight: "700",
                                        fontSize: "14px",
                                        color: "#374151",
                                        marginBottom: "12px",
                                        display: "block",
                                        flexShrink: 0,
                                    }}
                                >
                                    Select plan, then assign staff
                                </label>
                                <div
                                    className="plan-selector-global"
                                    style={{
                                        display: "flex",
                                        gap: "12px",
                                        flexWrap: "wrap",
                                        marginBottom: "16px",
                                        flexShrink: 0,
                                    }}
                                >
                                    {hourlyPackages.map((pkg, idx) => (
                                        <label
                                            key={idx}
                                            style={{
                                                padding: "10px 18px",
                                                borderRadius: "50px",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                fontSize: "14px",
                                                fontWeight:
                                                    selectedPackageIndex === idx
                                                        ? "700"
                                                        : "500",
                                                backgroundColor:
                                                    selectedPackageIndex === idx
                                                        ? "#eff6ff"
                                                        : "#f8fafc",
                                                border:
                                                    selectedPackageIndex === idx
                                                        ? "2px solid #3b82f6"
                                                        : "2px solid #e2e8f0",
                                            }}
                                        >
                                            <input
                                                type="radio"
                                                name="customize-plan-select"
                                                checked={selectedPackageIndex === idx}
                                                onChange={() =>
                                                    setSelectedPackageIndex(idx)
                                                }
                                            />
                                            {pkg.category || "Standard"} ({pkg.hours})
                                        </label>
                                    ))}
                                </div>
                            </>
                        ) : null}

                        <div className="customize-hourly-float-staff-wrap customize-hourly-float-accordion-wrap">
                            <RoleAccordion
                                key={role.roleKey}
                                roleKey={role.roleKey}
                                title={role.displayTitle}
                                bookingId={bookingId}
                                isOpen={isOpen}
                                services={role.showFilters ? services : []}
                                fetchListAPI={role.fetchListAPI}
                                fetchAllAPI={role.fetchAllAPI}
                                fetchSortAPI={role.fetchSortAPI}
                                showFilters={role.showFilters}
                                onSelectionChange={handleRoleSelectionChange}
                                hourlyPackages={hourlyPackages}
                                selectedPackageIndex={selectedPackageIndex}
                                onPackageSelect={setSelectedPackageIndex}
                                roleSelections={{ [role.roleKey]: [] }}
                                allPackagesSelections={{}}
                                refreshVersion={refreshVersion}
                                customizeMode
                                baseAmountOverride={baseAmount}
                            />
                        </div>

                        <div className="hourly-modal-footer customize-hourly-float-footer">
                            <button
                                className="btn-secondary"
                                type="button"
                                onClick={() => {
                                    resetAll();
                                    onClose();
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn-request btn-request-send"
                                disabled={!selectedIds?.length}
                                onClick={() =>
                                    handleFooterSendRequest(role.roleKey)
                                }
                            >
                                Send Request
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomizeHourlyFloatModal;
